var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/906a37fa377ab9c66e8117dabf7435e6.js').default;export default
        Object.assign({}, scope_0 )
    